import React from "react";
import usePyodideKernel from "../lib/usePyodideKernel";

export default function PyCell({
  code,
  title,
  runLabel = "Run",
  height = 180,
}) {
  const { ready, busy, output, run, clear, parseOutput } = usePyodideKernel();

  const parts = parseOutput(output);

  return (
    <div className="stt-card">
      {title ? <h3 className="stt-card-title">{title}</h3> : null}
      <div className="stt-card-body" style={{ display: "grid", gap: ".6rem" }}>
        <pre className="stt-pre" style={{ minHeight: height }}>
{code}
        </pre>
        <div style={{ display: "flex", gap: ".5rem", justifyContent: "flex-end" }}>
          <button className="stt-btn stt-btn-outline" onClick={() => navigator.clipboard.writeText(code)}>Copy</button>
          <button className="stt-btn stt-btn-outline" onClick={clear}>Clear Output</button>
          <button className="stt-btn" disabled={!ready || busy} onClick={() => run(code)}>
            {busy ? "Running…" : ready ? runLabel : "Starting Python…"}
          </button>
        </div>

        {/* Output render: text + any matplotlib images */}
        <div className="stt-pre" aria-live="polite">
          {parts.length === 0 ? " " : parts.map((p, i) =>
            p.type === "img"
              ? <img key={i} alt="plot" src={`data:image/png;base64,${p.b64}`} style={{ maxWidth: "100%" }} />
              : <div key={i}>{p.text}</div>
          )}
        </div>
      </div>
    </div>
  );
}
